import React from 'react';
import './ContentPlugins.css';

export default function PluginRenderingBar({ message }) {
  return (
    <div className="contentPluginRenderingWrap" role="status" aria-live="polite">
      <div className="contentPluginRenderingBarTrack" aria-hidden="true">
        <div className="contentPluginRenderingBarSweep" />
      </div>
      {message ? (
        <p className="contentPluginRenderingMessage">{message}</p>
      ) : null}
    </div>
  );
}
